import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { updatePassword } from "firebase/auth";
import { auth } from '../firebase';
import { secondaryModalSx } from '../styles/secondaryMsiStyles';
import { describeAuthError, getLinkedProviderIds } from '../utils/federatedAuth';

const ResetPasswordModal = ({
  open,
  onClose,
  handleResetPasswordModalClose,
  expectedUid,
  isPasswordConnected,
  onPasswordUpdated,
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePasswordUpdate = async () => {

    setError('');
    setSuccess('');

    if (!newPassword || !confirmPassword) {
      setError('Please fill out both fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;
      if (!user || !expectedUid || user.uid !== expectedUid) {
        throw Object.assign(new Error('Authentication session changed.'), {
          code: 'auth/user-mismatch',
        });
      }
      await updatePassword(user, newPassword);
      await user.reload();
      onPasswordUpdated?.(getLinkedProviderIds(user));
      setSuccess(isPasswordConnected ? 'Password updated successfully.' : 'Password sign-in enabled successfully.');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(function() {
            handleResetPasswordModalClose();
        }, 2000);
      
    } catch (err) {
      setError(describeAuthError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
          ...secondaryModalSx,
        }}
      >
        <Typography variant="h6" mb={2}>
          {isPasswordConnected ? 'Reset Password' : 'Set Password'}
        </Typography>

        {!isPasswordConnected && (
          <Typography variant="body2" color="text.secondary" mb={2}>
            Add password sign-in for your current Alphamizer email address.
          </Typography>
        )}

        <TextField
          fullWidth
          type="password"
          label="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={loading}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          type="password"
          label="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          disabled={loading}
          sx={{ mb: 2 }}
        />

        {error && (
          <Typography color="error" variant="body2" mb={2}>
            {error}
          </Typography>
        )}

        {success && (
          <Typography color="success.main" variant="body2" mb={2}>
            {success}
          </Typography>
        )}

        <Button
          variant="contained"
          fullWidth
          disabled={loading}
          onClick={handlePasswordUpdate}
        >
          {loading ? 'Updating...' : isPasswordConnected ? 'Update Password' : 'Set Password'}
        </Button>
      </Box>
    </Modal>
  );
};

export default ResetPasswordModal;
